import React, { useEffect, useState } from "react";
import TrainingAzureSearchPostList from "./TrainingAzureSearchPostList";
import { makeStyles, SwipeableDrawer } from "@material-ui/core";
import "./TrainingAzureSearchRootComponent.scss";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "react-js-pagination";
import TrainingAzureFilterRootComponent from "./TrainingAzureFilterRootComponent";
import { handleNotify } from "../../../../js/helpers/toaster/toaster-notify";
import { ToasterTypes } from "../../../../js/helpers/toaster/toaster-types";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {
    processTrainingParameterAndSendQuery,
    sendToURL,
    trainingSearchRelevance
} from "../../../../utilities/CommonUtilities";
import moment from "moment";
import qs from "qs";
import { useHistory } from "react-router-dom";
import {
    getTrainingAzureSearchData,
    staticTrainingAzureSearchData
} from "../../../../redux/training/training-new-search/training-azure-search.action";

function TrainingAzureSearchRootComponent() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const [openSwappableDrawer, setOpenSwappableDrawer] = useState(false);
    const [activePage, setActivePage] = useState(1);
    const [dynamicSearchData, setDynamicSearchData] = React.useState([])
    const [searchBoxText, setSearchBoxText] = React.useState("");

    const [filterSelection, setFilterSelection] = React.useState("");

    const [rangeState, setRangeState] = useState({
        min: moment().toDate().getTime(),
        max: moment().add(1, 'years').toDate().getTime(),
    });

    const currentTrainingAzureSearchData = useSelector(state => state.trainingAzureSearchData.currentSearchData);
    const lastSearchData = useSelector(state => state.trainingAzureSearchData.lastSearchData);

    useEffect(() => {
        let data = {}
        if (window.location?.pathname === "/training/webinar") {
            data = { ds: ["ByFormat|Webinar"] }
            setDynamicSearchData(["ByFormat|Webinar"])
            //setTimeout(() => dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data))), 0)
        } else if (window.location?.pathname === "/training/seminar") {
            data = { ds: ["ByFormat|Seminar"] }
            setDynamicSearchData(["ByFormat|Seminar"])
            //setTimeout(() => dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data))), 0)
        } else if (window.location?.pathname === "/training/complimentary") {
            data = { ds: ["ByFormat|Complimentary"] }
            setDynamicSearchData(["ByFormat|Complimentary"])
            //setTimeout(() => dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data))), 0)
        } else if (window.location?.pathname === "/training/classroom") {
            data = { ds: ["ByFormat|Classroom"] }
            setDynamicSearchData(["ByFormat|Classroom"])
            //setTimeout(() => dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data))), 0)
        } else if (window.location?.pathname === "/training/course-by-category/air-quality-modeling") {
            data = { ds: ["ByCategory|Air Quality Modeling"] }
            setDynamicSearchData(["ByCategory|Air Quality Modeling"])
            //setTimeout(() => dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data))), 0)
        } else if (window.location?.pathname === "/training/course-by-category/ehs-regulations") {
            data = { ds: ["ByCategory|EHS Regulations"] }
            setDynamicSearchData(["ByCategory|EHS Regulations"])
            //setTimeout(() => dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data))), 0)
        } else if (window.location?.pathname === "/training/course-by-category/ehs-s-management") {
            data = { ds: ["ByCategory|EHS&S Management"] }
            setDynamicSearchData(["ByCategory|EHS&S Management"])
            //setTimeout(() => dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data))), 0)
        } else if (window.location?.pathname === "/training/course-by-category/environmental-analysis") {
            data = { ds: ["ByCategory|Environmental Analysis"] }
            setDynamicSearchData(["ByCategory|Environmental Analysis"])
            //setTimeout(() => dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data))), 0)
        } else if (window.location?.pathname === "/training/course-by-category/environmental-reporting") {
            data = { ds: ["ByCategory|Environmental Reporting"] }
            setDynamicSearchData(["ByCategory|Environmental Reporting"])
            //setTimeout(() => dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data))), 0)
        } else if (window.location?.pathname === "/training/industry/industrial-hygiene") {
            data = { ds: ["ByCategory|Industrial Hygiene"] }
            setDynamicSearchData(["ByCategory|Industrial Hygiene"])
            //setTimeout(() => dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data))), 0)
        }
        else if (window.location?.pathname === "/training/industry/industry-specific") {
            data = { ds: ["ByCategory|Industry Specific"] }
            setDynamicSearchData(["ByCategory|Industry Specific"])
            //setTimeout(() => dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data))), 0)
        } else if (window.location?.pathname === "/training/industry/life-science") {
            data = { ds: ["ByCategory|Life Science"] }
            setDynamicSearchData(["ByCategory|Life Science"])
            //setTimeout(() => dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data))), 0)
        } else if (window.location?.pathname === "/training/course-by-category/location-specific") {
            data = { ds: ["ByCategory|Location Specific"] }
            setDynamicSearchData(["ByCategory|Location Specific"])
            //setTimeout(() => dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data))), 0)
        } else if (window.location?.pathname === "/training/software/software-courses") {
            data = { ds: ["ByCategory|Software Courses"] }
            setDynamicSearchData(["ByCategory|Software Courses"])
            //setTimeout(() => dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data))), 0)
        }

        if (window.location.search.length > 0) {
            data = qs.parse(window.location.search.substring(1))

            if (data?.ds)
                setDynamicSearchData(data?.ds)

            if (data?.rs)
                setRangeState({
                    min: Number.parseInt(data?.rs.min),
                    max: Number.parseInt(data?.rs.max)
                })

            if (data?.sbt)
                setSearchBoxText(data?.sbt)

            if (data?.drp)
                setFilterSelection(data?.drp)

            if (data?.pg)
                setActivePage(data?.pg)

            //setTimeout(() => dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data))), 0)
        }
        // else {
        //     dispatch(getTrainingAzureSearchData(staticTrainingAzureSearchData))
        // }
        //setTimeout(() => dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data))), 1500)
        //dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data)));

        if (Object.keys(data).length > 0) {
            dispatch(getTrainingAzureSearchData(processTrainingParameterAndSendQuery(staticTrainingAzureSearchData, data)));
        }
        else {
            dispatch(getTrainingAzureSearchData(staticTrainingAzureSearchData))
        }
    }, [window.location])

    useEffect(() => {
        setFilterSelection(lastSearchData.orderby)
    }, [lastSearchData])

    const toggleDrawer = () => {
        setOpenSwappableDrawer(e => !e)
    };

    const getFilterButton = () => {
        return (
            <div className="resource-filter-btn">
                <div style={{ marginBottom: "1rem" }}>
                    {
                        currentTrainingAzureSearchData.totalDocumentCount > 0
                            ?
                            currentTrainingAzureSearchData.totalDocumentCount < 10
                                ?
                                <span> Showing {currentTrainingAzureSearchData.totalDocumentCount} courses </span>
                                :
                                <span> Showing {(activePage * 10) - 9} - {activePage * 10} of {currentTrainingAzureSearchData.totalDocumentCount} courses </span>
                            :
                            <span> No Results Available </span>
                    }
                </div>

                <button className="button-style" onClick={toggleDrawer}>
                    <i className="fa fa-filter" style={{ fontSize: "20px" }}
                        aria-hidden="true" />
                </button>
            </div>
        )
    }

    const handlePageChange = (pageNumber) => {
        // let newObject = Object.assign({}, lastSearchData, {"skip": (pageNumber * 10) - 10})
        // dispatch(getTrainingAzureSearchData(newObject))
        let data = {
            ds: dynamicSearchData,
            sbt: searchBoxText,
            rs: rangeState,
            pg: pageNumber,
            drp: filterSelection
        }
        sendToURL(history, data)
        setActivePage(pageNumber);
    }


    const onChangeDynamicCheckBox = (parentKey, selectedValue, isChecked) => {
        let preparedArray = []

        if (isChecked) {
            preparedArray = dynamicSearchData.concat(parentKey + "|" + selectedValue)
            setDynamicSearchData(preparedArray)
        } else {
            preparedArray = dynamicSearchData.filter(e => e !== parentKey + "|" + selectedValue);
            setDynamicSearchData(preparedArray)
        }

        let newArray = preparedArray.map((outerElement, index) => {
            let key = outerElement.split("|")[0]
            let value = outerElement.split("|")[1]

            if ((preparedArray.length - 1) === index) {
                return "(" + key + " eq '" + value + "')"
            } else {
                return "(" + key + " eq '" + value + "') and "
            }
        })

        let dynamicString = newArray.toString().split(",").join("")
        let preparedDate = moment(rangeState.min).toISOString() + "|" + moment(rangeState.max).toISOString()
        let newDateString = "DatePublished,values: " + preparedDate
        let finalChangedData = lastSearchData.facets.filter(e => !e.includes("DatePublished"))

        let finalFilterString = "";

        finalFilterString = dynamicString.replace(/[ ]/g, '').length > 0
            // ? "DatePublished ge " + moment(rangeState.min).toISOString() + " and DatePublished le " + moment(rangeState.max).toISOString() + " and " + dynamicString
            ? dynamicString
            : ""

        let newObject = Object.assign({}, lastSearchData,
            { "filter": finalFilterString },
            { "facets": finalChangedData.filter(e => e !== e.toString().includes("DatePublished")).concat(newDateString) },
            { "skip": 0 })

        dispatch(getTrainingAzureSearchData(newObject))


        setTimeout(() => {
            let data = {
                ds: preparedArray,
                sbt: searchBoxText,
                pg: 1,
                drp: filterSelection
            }
            console.log(data)
            sendToURL(history, data)

            setActivePage(1)
        }, 1000)
    }

    const resetAllFiltersAndSearch = () => {
        if (lastSearchData !== staticTrainingAzureSearchData) {
            setOpenSwappableDrawer(false)
            setActivePage(1)
            setDynamicSearchData([])
            setSearchBoxText("")
            setRangeState({
                min: moment().toDate().getTime(),
                max: moment().add(1, 'years').toDate().getTime(),
            })
            dispatch(getTrainingAzureSearchData(staticTrainingAzureSearchData))
            window.history.replaceState(null, "", `${history?.location?.pathname}`)
        } else {
            handleNotify('There are no filters applied.', ToasterTypes.Error);
        }
    }

    const rangePickerChangeComplete = value => {

        let preparedDate = moment(value.min).toISOString() + "|" + moment(value.max).toISOString()
        let newDateString = "DatePublished,values: " + preparedDate

        let finalChangedData = lastSearchData.facets.filter(e => !e.includes("DatePublished"))

        let currentData = lastSearchData.filter.toString().split("and")

        let preparedData = currentData.map((element, index) => {
            if (element.includes("DatePublished")) {
                return ""
            } else if ((currentData.length - 1) === index) {
                return element
            } else {
                return element + " and "
            }
        }).toString().split(",").join("")

        let newFilters = ""

        if (preparedData.length === 0) {
            newFilters = "DatePublished ge " + moment(rangeState.min).toISOString() + " and DatePublished le " + moment(rangeState.max).toISOString()
        } else {
            newFilters = preparedData + " DatePublished ge " + moment(rangeState.min).toISOString() + " and DatePublished le " + moment(rangeState.max).toISOString()
        }

        let data = {
            ds: dynamicSearchData,
            sbt: searchBoxText,
            rs: value,
            pg: activePage,
            drp: filterSelection
        }
        setTimeout(() => {
            let newObject = Object.assign({}, lastSearchData,
                { "facets": finalChangedData.filter(e => e !== e.toString().includes("DatePublished")).concat(newDateString) },
                { "filter": newFilters })

            sendToURL(history, data)
            dispatch(getTrainingAzureSearchData(newObject))
        }, 2000)
    }

    const onSearchEnter = () => {
        let searchTextData = "";

        if (searchBoxText.trim().toString().length === 0) {
            searchTextData = "*"
        } else {
            searchTextData = searchBoxText
        }

        let newObject = Object.assign({}, lastSearchData, { "search": searchTextData });
        dispatch(getTrainingAzureSearchData(newObject))

        setTimeout(() => {
            let data = {
                ds: dynamicSearchData,
                sbt: searchBoxText,
                rs: rangeState,
                pg: 1,
                drp: filterSelection
            }
            sendToURL(history, data)

            setActivePage(1)
        }, 1000)
    }

    const onChangeHandleChange = value => {
        setRangeState(value);
    }

    const getCommonResourceFilter = () => {
        return (
            <TrainingAzureFilterRootComponent
                searchBoxText={searchBoxText}
                setSearchBoxText={setSearchBoxText}
                onSearchEnter={onSearchEnter}
                dynamicSearchData={dynamicSearchData}
                openSwappableDrawer={openSwappableDrawer}
                rangeState={rangeState}
                setRangeState={setRangeState}
                onChangeHandleChange={onChangeHandleChange}
                rangePickerChangeComplete={rangePickerChangeComplete}
                facetsList={currentTrainingAzureSearchData && currentTrainingAzureSearchData.preparedSearchFacets}
                onChangeDynamicCheckBox={onChangeDynamicCheckBox}
                isShowRedIcon={lastSearchData === staticTrainingAzureSearchData}
                resetAllFiltersAndSearch={resetAllFiltersAndSearch}
            />
        )
    }

    const onChangeDropDownData = (key) => {
        let newObject = {}
        if (key === "relevance") {
            newObject = Object.assign({}, lastSearchData, { "orderby": "" })
        } else {
            newObject = Object.assign({}, lastSearchData, { "orderby": key })
        }

        let data = {
            ds: dynamicSearchData,
            sbt: searchBoxText,
            pg: activePage,
            drp: key
        }
        sendToURL(history, data)

        dispatch(getTrainingAzureSearchData(newObject))
    };

    return (
        <React.Fragment>
            <div>
                <div className="resource-search-outer-container">
                    <div className="main-content">
                        <div className="search-filter-container">
                            {getFilterButton()}
                        </div>
                        <div className="activity-container">
                            <div className={"active-resource-left-column"}>
                                <div className="active-search-filter">
                                    {getCommonResourceFilter()}

                                    <div className="active-search-filter desktop-mode">
                                        <SwipeableDrawer
                                            classes={{
                                                paper: classes.drawerPaper,
                                            }}
                                            anchor={'right'}
                                            open={openSwappableDrawer}
                                            onClose={toggleDrawer}
                                            onOpen={toggleDrawer}>
                                            {getCommonResourceFilter()}
                                        </SwipeableDrawer>
                                    </div>
                                </div>
                            </div>

                            <div className="active-block">
                                <div>
                                    <div className={"root-search-outer-top-container"}>
                                        <div className={"left-outer-search-container"}>
                                            <div style={{ marginBottom: "1rem" }}>
                                                {
                                                    currentTrainingAzureSearchData.totalDocumentCount > 0
                                                        ?
                                                        currentTrainingAzureSearchData.totalDocumentCount < 10
                                                            ?
                                                            <span> Showing {currentTrainingAzureSearchData.totalDocumentCount} courses </span>
                                                            :
                                                            <span> Showing {(activePage * 10) - 9} - {activePage * 10} of {currentTrainingAzureSearchData.totalDocumentCount} courses </span>
                                                        :
                                                        <span> No Results Available </span>
                                                }
                                            </div>
                                        </div>

                                        <div className={"right-outer-search-container"}>
                                            <FormControl fullWidth variant={"outlined"} size={"small"}>
                                                <InputLabel id="relevance-outlined-label">Sort By</InputLabel>
                                                <Select
                                                    labelId="relevance-label"
                                                    id="relevance-selector"
                                                    value={!filterSelection ? "relevance" : filterSelection}
                                                    onChange={(e) => onChangeDropDownData(e.target.value)}
                                                    label="Relevance">
                                                    <MenuItem value={"relevance"}>{"Relevance"}</MenuItem>
                                                    {
                                                        trainingSearchRelevance.map(element => {
                                                            return (
                                                                <MenuItem value={element.key}>{element.value}</MenuItem>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                </div>

                                <TrainingAzureSearchPostList
                                    activePage={activePage}
                                    valueList={currentTrainingAzureSearchData?.preparedGroupedList} />

                                {
                                    currentTrainingAzureSearchData && currentTrainingAzureSearchData?.preparedGroupedList?.length > 0
                                    &&
                                    <div className={"resource-search-pagination-outer"}>
                                        <Pagination
                                            className={"pagination"}
                                            prevPageText='Previous'
                                            nextPageText='Next'
                                            hideDisabled={true}
                                            activePage={activePage}
                                            itemsCountPerPage={10}
                                            totalItemsCount={currentTrainingAzureSearchData.totalDocumentCount}
                                            pageRangeDisplayed={3}
                                            onChange={handlePageChange}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: 400,
            flexShrink: 0,
        },
    },
    drawerPaper: {
        width: 350,
    },
}));

export default TrainingAzureSearchRootComponent;
